import { render, staticRenderFns } from "./block-cta.vue?vue&type=template&id=63e01035&scoped=true&"
import script from "./block-cta.vue?vue&type=script&lang=js&"
export * from "./block-cta.vue?vue&type=script&lang=js&"
import style0 from "./block-cta.vue?vue&type=style&index=0&id=63e01035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e01035",
  null
  
)

export default component.exports